import { useEffect, useLayoutEffect, useRef } from 'react';
import mermaid from 'mermaid';

type GraphProps<NodeType extends object> = {
  nodes: NodeType[];
  edges: IEdge<NodeType>[];
  getId: (edge: NodeType) => string;
  getName: (edge: NodeType) => string;
};

interface IEdge<NodeType> {
  child: NodeType;
  parent: NodeType;
}

mermaid.initialize({ startOnLoad: true, wrap: true });

export const Graph = <NodeType extends object>({ edges, nodes, getId, getName }: GraphProps<NodeType>) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const _getId = (node: NodeType) => {
    return getId(node).replace(/ /g, '_');
  };

  useLayoutEffect(() => {
    ref.current?.removeAttribute('data-processed');
  }, [edges, nodes]);

  useEffect(() => {
    mermaid.contentLoaded();
  }, [edges, nodes]);

  const code = `graph TD;${nodes.map((node) => `${_getId(node)}["${getName(node)}"];`).join('')}${edges
    .map((edge) => `${_getId(edge.parent)}-->${_getId(edge.child)};`)
    .join('')}`;

  return (
    <div ref={ref} className="mermaid">
      {code}
    </div>
  );
};
